/**
 * Created by vsuthar on 9/24/21
 * File: ProductNameRendere
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import React, { useMemo } from 'react'
import { Body, Bold } from '@panwds/react-ui'
import { ARRAY } from '../common/utils'
import appNames from '../common/appNames'

const ProductNameRenderer = (props: any) => {
  const { value, row, apps = {} } = props
  const [app_id, original] = useMemo(() => {
    let app_id = value
    let original = row?.original
    if (row?.depth === 0 && ARRAY.hasArray(row?.subRows) && !row?.isExpanded) {
      app_id = row?.subRows[0]?.original?.app_id
      original = row?.subRows[0]?.original
    }
    return [app_id, original]
  }, [row?.depth, row?.isExpanded, row?.original, row?.subRows, value])


  const appName = useMemo(() => {
    return appNames(apps).getAppName(app_id, '') === 'None' ? '' :
      appNames(apps).getAppName(original?.app_id_display_override || app_id, original?.app_id_display_override)
  }, [app_id, apps, original?.app_id_display_override])


  return (
    <div className="tw-h-full tw-truncate tw-flex-col tw-flex tw-justify-center">
      {appName && (
        <Body size='xs' addClassName='tw-flex tw-flex-row tw-items-center tw-text-blue-600 tw-truncate tw-h-full'><Bold>{appName}</Bold></Body>
      )}
    </div>
  )
}

ProductNameRenderer.propTypes = {}
export default ProductNameRenderer

